/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path d="M10.3 20.5864C10.4674 20.8909 10.7135 21.1448 11.0125 21.3216C11.3116 21.4985 11.6526 21.5918 12 21.5918C12.3475 21.5918 12.6885 21.4985 12.9876 21.3216C13.2866 21.1448 13.5327 20.8909 13.7 20.5864M6 7.58643C6 5.99513 6.63214 4.469 7.75736 3.34379C8.88258 2.21857 10.4087 1.58643 12 1.58643C13.5913 1.58643 15.1174 2.21857 16.2426 3.34379C17.3679 4.469 18 5.99513 18 7.58643C18 14.5864 21 16.5864 21 16.5864H3C3 16.5864 6 14.5864 6 7.58643Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
